import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import rocket from 'assets/images/login/rocket-new.png';
import slickLogo from 'assets/images/logos/slick-logo-text-white.png';
import { FormCard } from 'components/onboarding/FormCard.component';
import { OnboardingLayout } from 'components/onboarding/OnboardingLayout.component';
import LINK from 'constants/link.const';
import { useNavFor } from 'hooks/useNav.hook';
import { useTranslation } from 'providers/GILT.provider';
import { fromSearchToQueryString } from 'utils/converters/props/path.util';

import CN from './SalonSetupInfo.module.scss';

const CTAG = 'SalonSetupInfo';

export const SalonSetupInfo = () => {
  const nav = useNavFor(CTAG);
  const location = useLocation();
  const searchQuery = fromSearchToQueryString(location.search);
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    nav.push({ pathname: LINK.onboardingType, search: searchQuery });
  }, [nav, searchQuery]);

  return (
    <OnboardingLayout mobileHeader={<img src={slickLogo} alt="Slick logo" className={CN.logo} />}>
      <FormCard header={<h2 className={CN.title}>{t('register.salonSetupInfo.title')}</h2>} submitButtonLabel={t('register.salonSetupInfo.submitButton')} onSubmit={handleClick}>
        <article className={CN.content}>
          <span className={CN.rocketIcon}>
            <img src={rocket} alt="" />
          </span>
          <h3 className={CN.cardTitle}>{t('register.salonSetupInfo.cardTitle')}</h3>
          <p className={CN.cardDescription}>{t('register.salonSetupInfo.cardDescription')}</p>
        </article>
      </FormCard>
    </OnboardingLayout>
  );
};
